export const Documents = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_293_25357)">
      <path
        d="M12.25 1.75065H7.13767L4.80433 0.583984H1.75C1.28587 0.583984 0.840752 0.768359 0.512563 1.09655C0.184374 1.42474 0 1.86986 0 2.33398L0 13.4173H14V3.50065C14 3.03652 13.8156 2.5914 13.4874 2.26321C13.1592 1.93503 12.7141 1.75065 12.25 1.75065ZM1.75 1.75065H4.529L6.86233 2.91732H12.25C12.4047 2.91732 12.5531 2.97878 12.6625 3.08817C12.7719 3.19757 12.8333 3.34594 12.8333 3.50065V4.01457L1.16667 4.08048V2.33398C1.16667 2.17927 1.22812 2.0309 1.33752 1.92151C1.44692 1.81211 1.59529 1.75065 1.75 1.75065ZM1.16667 12.2507V5.24715L12.8333 5.18123V12.2507H1.16667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_25357">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
